var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"show-iframe"},[_c('webview',{attrs:{"url":_vm.getUrl,"isHtml":""}}),_vm._v(" "),(!_vm.url)?_c('div',{staticClass:"list-empty"},[_c('img',{attrs:{"src":require("../../../assets/image/change-icon/empty_details@2x.png")}}),_vm._v(" "),_c('p',[_vm._v("本商品暂无详情")])]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-448b0450","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/product-detail/child/DescItem.vue
// module id = null
// module chunks = 